// extracted by mini-css-extract-plugin
export default {"text":"NotesTemplate_text__1+KNi","addText":"NotesTemplate_addText__qTk59","icon":"NotesTemplate_icon__CWmSs","iconWithValue":"NotesTemplate_iconWithValue__C28ox"};